// extracted by mini-css-extract-plugin
module.exports = {"bp-desktop-medium-viewport":"(min-width: 1280px)","bp-tablet-small-viewport":"(min-width: 768px)","inline":"reference-item_inline__IpiFW","desktop":"reference-item_desktop__3v33P"};